import { useCurrentUser } from '@atlassian/jira-platform-services-user-current';

export const useUserTimezone = () => {
	const { data: userData } = useCurrentUser();
	const timeZone = 'timeZone' in userData.user ? userData.user.timeZone || 'UTC' : 'UTC';
	return { timeZone };
};
